import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import WorldPage from "@/pages/WorldPage";
import Credits from "@/pages/Credits";
import Contact from "@/pages/Contact";
import Merch from "@/pages/Merch";
import Nft from "@/pages/Nft";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/world/:id" element={<WorldPage />} />
            <Route path="/credits" element={<Credits />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/nft" element={<Nft />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#f2f0ec",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "12px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
